import { style, styleVariants } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { vars } from "../../styles/theme.css";

const baseAlertStyles = style({
  margin: `${vars.space["2xs"]} 0`,
  borderRadius: vars.radii.s,
  padding: `${vars.space.xs} ${vars.space.m}`,
  fontSize: vars.fontSizes.body.m,
});

export const alertStyles = recipe({
  base: baseAlertStyles,
  variants: {
    variant: {
      default: {
        backgroundColor: vars.colors.inverseSurface,
        color: vars.colors.inverseOnSurface,
      },
      error: {
        backgroundColor: vars.colors.error,
        color: vars.colors.onError,
      },
      success: {
        backgroundColor: vars.colors.success,
        color: vars.colors.onSuccess,
      },
      light: {
        backgroundColor: vars.colors.primaryContainer,
        color: vars.colors.onPrimaryContainer,
      },
    },
    hasIcon: {
      true: {
        display: "flex",
        alignItems: "center",
        gap: vars.space.m,
      },
    },
    isInline: {
      true: { display: "inline-block" },
    },
    isContentCentered: {
      true: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  },
});

export const alertContent = style({
  lineHeight: 1.4,
});

export const alertCenteredContainer = style({
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
});

export const alertIcon = style({
  width: 16,
  height: 16,
});

const elementNewsAlertBaseStyles = style([
  baseAlertStyles,
  {
    display: "flex",
    alignItems: "center",
    gap: vars.space.m,
    fontFamily: vars.fonts.bold,
  },
]);

export const elementNewsAlertStyles = styleVariants({
  0: [
    elementNewsAlertBaseStyles,
    {
      backgroundColor: vars.colors.copnr[0].backgroundColor,
      color: vars.colors.copnr[0].color,
    },
  ],
  25: [
    elementNewsAlertBaseStyles,
    {
      backgroundColor: vars.colors.copnr[25].backgroundColor,
      color: vars.colors.copnr[25].color,
    },
  ],
  50: [
    elementNewsAlertBaseStyles,
    {
      backgroundColor: vars.colors.copnr[50].backgroundColor,
      color: vars.colors.copnr[50].color,
    },
  ],
  75: [
    elementNewsAlertBaseStyles,
    {
      backgroundColor: vars.colors.copnr[75].backgroundColor,
      color: vars.colors.copnr[75].color,
    },
  ],
});
